import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { format } from 'date-fns';
import TrailerStatusChip, { TRAILER_STATUS_TIP } from '../../components/TrailerStatusChip';
import { compartmentsNumber, trailerCapacity } from '../../utils';

const propertySkeleton = (
  <Box sx={{ diplay: 'table', mr: 4, mt: 3 }}>
    <Typography gutterBottom variation="body2">
      <Skeleton width={97} />
    </Typography>
    <Typography variation="body1">
      <Skeleton width={50} />
    </Typography>
  </Box>
);

const boxStyles = {
  display: 'grid',
  gridColumnGap: 32,
  gridTemplateColumns: '116px 68px 88px',
  mt: 3,
};

const TrailerProperties = ({ isSuccess, trailer }) => {
  const { compartments = [], expirationDate, status } = trailer;

  // prettier-ignore
  if (!isSuccess) return (
    <Box sx={boxStyles}>
      {propertySkeleton}
      {propertySkeleton}
      {propertySkeleton}
    </Box>
  );

  const trailerCpcty = trailerCapacity(compartments);
  const displayStatusTip = ['PENDING', 'WARNING'].includes(status);

  return (
    <>
      <Stack alignItems="center" direction="row" spacing={2} sx={{ mb: 2 }}>
        <TrailerStatusChip status={status} />
        {displayStatusTip && (
          <Tooltip
            placement="top"
            slotProps={{
              popper: { sx: { p: 1, textAlign: 'center' } },
            }}
            title={TRAILER_STATUS_TIP[status]}
          >
            <InfoRoundedIcon sx={{ '&:hover': { cursor: 'pointer' }, color: 'graphic.main' }} />
          </Tooltip>
        )}
      </Stack>
      <Box sx={boxStyles}>
        <Typography gutterBottom variation="body2">
          Compartments
        </Typography>
        <Typography gutterBottom variation="body2">
          Capacity
        </Typography>
        <Typography gutterBottom variation="body2">
          Expiration
        </Typography>

        <Typography variation="body1">{compartmentsNumber(compartments)}</Typography>
        <Typography variation="body1">
          {trailerCpcty > 0 ? `${trailerCpcty}gal` : trailerCpcty}
        </Typography>
        {expirationDate && (
          <Typography variation="body1">
            {format(new Date(expirationDate), 'MM/dd/yyyy')}
          </Typography>
        )}
      </Box>
    </>
  );
};

TrailerProperties.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  trailer: PropTypes.shape({
    compartments: PropTypes.arrayOf(PropTypes.shape({})),
    expirationDate: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

export default TrailerProperties;
